module.exports = __webpack_public_path__ + "static/media/NTC.a2e27de1.svg";